<ng-container *transloco="let t; read: 'banner'">
  <div class="banner">
    <div class="accredible-content">
      <img src="/assets/images/directory-of-directories/dod_banner_image.svg" alt="" />
      <div class="text-container">
        <h1>{{ t('title') }}</h1>
        <p>
          {{ t('subtitle') }}
        </p>

        <div class="logos-container">
          <div class="logos-scroll">
            <div class="logos-track">
              <ng-container *ngTemplateOutlet="logos" />

              <div class="extra-logos">
                <ng-container *ngTemplateOutlet="logos" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #logos>
    <img
      src="/assets/images/directory-of-directories/banner_logos/snowflake.png"
      [alt]="t('logos.snowflake')" />
    <img
      src="/assets/images/directory-of-directories/banner_logos/google.png"
      [alt]="t('logos.google')" />
    <img
      src="/assets/images/directory-of-directories/banner_logos/american_board.png"
      [alt]="t('logos.american_board')" />
    <img
      src="/assets/images/directory-of-directories/banner_logos/wharton.png"
      [alt]="t('logos.wharton')" />
  </ng-template>
</ng-container>
